// reCAPTCHA v3 — env-gated, lazy, client-only loader (react-snap safe).
// No-op when REACT_APP_RECAPTCHA_SITE_KEY is absent.

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

let loadPromise = null;

const isBrowser = () => typeof window !== 'undefined' && typeof document !== 'undefined';
const isPrerender = () => isBrowser() && navigator.userAgent === 'ReactSnap';

const loadScript = () => {
  if (loadPromise) return loadPromise;
  loadPromise = new Promise((resolve) => {
    if (window.grecaptcha && window.grecaptcha.ready) {
      window.grecaptcha.ready(() => resolve(window.grecaptcha));
      return;
    }
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      if (window.grecaptcha && window.grecaptcha.ready) {
        window.grecaptcha.ready(() => resolve(window.grecaptcha));
      } else {
        resolve(null);
      }
    };
    script.onerror = () => resolve(null);
    document.head.appendChild(script);
  });
  return loadPromise;
};

export const getRecaptchaToken = async (action = 'lead_submit') => {
  if (!SITE_KEY || !isBrowser() || isPrerender()) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.log('[LQE] reCAPTCHA skipped (no site key / non-browser env)');
    }
    return null;
  }
  try {
    const grecaptcha = await loadScript();
    if (!grecaptcha || !grecaptcha.execute) return null;
    const token = await grecaptcha.execute(SITE_KEY, { action });
    return token || null;
  } catch {
    return null;
  }
};
